import React, {useEffect, useState} from "react";
import SiteContent from "../components/site-items/SiteContent/SiteContent";
import Navbar from "../parts/Navbar/Navbar";
import Footer from "../parts/Footer/Footer";
import PageWrapper from "../components/page-items/PageWrapper/PageWrapper";
import Logo from "../components/logos/Logo/Logo";
import PageHeader from "../components/page-items/PageHeader/PageHeader";
import PageContent from "../components/page-items/PageContent/PageContent";
import NewsContainer from "../sections/News/NewsContainer/NewsContainer";
import Post from "../sections/News/Post/Post";
import PageSelector from "../sections/News/PageSelector/PageSelector";
import {scrollToTop} from "../helpers/helpersFunctions";
import Menu from "../components/buttons/Menu/Menu";
import {fetchData} from "../helpers/fetchData";
import SectionHeader from "../components/section-items/SectionHeader/SectionHeader";
import SectionSubheader from "../components/section-items/SectionSubheader/SectionSubheader";
import SectionBody from "../components/section-items/SectionBody/SectionBody";
import LoadingSpinner from "../components/spinners/LoadingSpinner";

const News = () => {

    const [posts, setPosts] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [isFetching, setIsFetching] = useState(true);

    useEffect(() => {
        scrollToTop();
        fetchPosts(1);
    }, []);

    useEffect(() => {
        fetchPosts(page);
    }, [page]);

    const fetchPosts = (page) => {
        fetchData('posts?page=' + page)
            .then((res) => {
                setPosts(res.results);
                setPage(res.page);
                setTotalPages(res.total_pages);
            })
            .then(() => setIsFetching(false))
            .catch((e) => console.error(e));
    }

    const renderPosts = () => {
        return posts.map(e =>
            <Post key={e.title + e.date}
                  images={e.images}
                  title={e.title}
                  date={e.date}
                  text={e.text}
                  id={e.id}
            />
        );
    };

    return (
        <SiteContent>
            <Navbar/>
            <PageWrapper style={{background: 'linear-gradient(#F7FAF2, 90%, #fdeaa7)'}}>
                <PageContent>
                    <PageHeader header={'News'}/>
                    <SectionBody>
                        <SectionHeader>{'Śledź najnowsze informacje'}</SectionHeader>
                        <SectionSubheader>{'Bądź na bieżąco ze wszystkimi wydarzenia związanymi z naszym klubem. Zawsze informujemy Was regularnie o wszystkich istotnych wydarzeniach!'}</SectionSubheader>
                        <NewsContainer>{ isFetching ? <LoadingSpinner/> : renderPosts() }</NewsContainer>
                        <PageSelector numberOfPages={totalPages} page={page} setPage={setPage}/>
                    </SectionBody>
                </PageContent>
                <Logo width={600}
                      height={600}
                      style={{
                          position: 'absolute', right: -160, bottom: -140,
                          opacity: 0.07, transform: 'rotate(12deg)', zIndex: 0
                      }}
                />
            </PageWrapper>
            <Menu/>
            <Footer/>
        </SiteContent>
    );
};

export default News;
